// @flow

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { FormattedMessage } from 'react-intl';
import { Grid, type ThemeType } from '@catalytic/catalytic-ui';
import classNames from 'classnames';
import { CONTACT_US, TERMS_PRIVACY, WWW } from '../const/url';

export const useStyles = makeStyles((theme: ThemeType) => {
  return {
    root: {
      margin: '0.5rem 0 1rem',
      textAlign: 'center'
    },
    fullScreen: {
      [theme.breakpoints.gt.tablet.landscape]: {
        height: '6.2rem'
      }
    },
    footer: {
      ...theme.typography.extraSmallText,
      color: theme.colors.battleshipGrey
    },
    footerItems: {
      margin: '0 0.625rem'
    }
  };
});

type Props = { splitScreen?: boolean };

export const LoginFooter = ({ splitScreen }: Props) => {
  const classes = useStyles();
  return (
    <Grid
      alignItems="flex-end"
      container
      data-testid="login-footer"
      direction="row"
      justify="center"
      wrap="nowrap"
      className={classNames(classes.root, {
        [classes.fullScreen]: !splitScreen
      })}
    >
      <Grid item className={classes.footerItems}>
        <a
          className={classes.footer}
          data-testid="login-footer-www"
          rel="noopener noreferrer"
          target="_blank"
          href={WWW}
        >
          <FormattedMessage id="login-footer.www" defaultMessage="PagerDuty" />
        </a>
      </Grid>
      <Grid item className={classes.footerItems}>
        <a
          className={classes.footer}
          data-testid="login-footer-contact"
          rel="noopener noreferrer"
          target="_blank"
          href={CONTACT_US}
        >
          <FormattedMessage
            id="login-footer.catalytic"
            defaultMessage="Contact"
          />
        </a>
      </Grid>
      <Grid item className={classes.footerItems}>
        <a
          className={classes.footer}
          data-testid="login-footer-privacy"
          rel="noopener noreferrer"
          target="_blank"
          href={TERMS_PRIVACY}
        >
          <FormattedMessage
            id="login-footer.privacy"
            defaultMessage="Privacy"
          />
        </a>
      </Grid>
    </Grid>
  );
};

LoginFooter.displayName = 'LoginFooter';

export default LoginFooter;
